import { Stack, Typography } from "@mui/material";

import { EXPERIMENT_MISSION_PROCESSING_STATUS } from "../../../constants";
import { TrafficTable } from "../";

export const CompletedTraffic = () => {
    const statusFilterString = `processingStatus[0]=${EXPERIMENT_MISSION_PROCESSING_STATUS.ABORTED}&processingStatus[1]=${EXPERIMENT_MISSION_PROCESSING_STATUS.SUCCESS}`;
    return (
        <Stack spacing={2}>
            <Typography variant="h4">Completed Traffic</Typography>
            <TrafficTable statusFilterString={statusFilterString} />
        </Stack>
    );
};
